import axios from 'axios';
import {apiBaseUrl} from "../../../helpers/UrlHelper";
import {loginToken} from '../../../helpers/LocalStorageHelper'
import {handleError} from '../../../helpers/ErrorHelper'

function _success(success) {
    return {type: 'GET_DATA_CENTER_SERVER_MODULE_SUCCESS', success};
}

function _error(error) {
    return {type: 'GET_DATA_CENTER_SERVER_MODULE_ERROR', error};
}

function _processing(processing) {
    return {type: 'GET_DATA_CENTER_SERVER_MODULE_PROCESSING', processing};
}

function getDataCenterServerModule(id) {
    return (dispatch) => {
        dispatch(_processing(true));
        dispatch(_success(null));
        dispatch(_error(null));

        const request = axios({
            url: apiBaseUrl(`admin/datacenters/${id}/servers`),
            method: "get",
            dataType: 'json',
            headers: {'Authorization': 'Bearer ' + loginToken()}
        })
            .then(function (res) {
                dispatch(_success(res));
                dispatch(_processing(false));

            }).catch(function (error) {
                handleError(error)
                dispatch(_error(error));
                dispatch(_processing(false));
            });
        return {
            type: 'GET_DATA_CENTER_SERVER_MODULE_SUCCESS',
            payload: request
        }
    }
}

export default getDataCenterServerModule;